module.exports = __webpack_public_path__ + "static/media/LOVES_THE_WATER.b9035124.svg";